<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="存货类型"
      edit-title
      id-key="ProductTypeId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
         <el-form-item label="编码" prop="ProductTypeNo">
          <el-input v-model="data.ProductTypeNo" placeholder="请输入编码" />
          <!-- <span v-if="Mode==0" class="detail-span">{{data.ProductTypeNo}}</span>
          <el-input v-else v-model="data.ProductTypeNo" placeholder="请输入分类编码"></el-input> -->
        </el-form-item>
        <el-form-item label="名称" prop="ProduceTypeName">
          <el-input v-model="data.ProduceTypeName" placeholder="请输入名称" />
        </el-form-item>
       <el-form-item label="所属大类" prop="TypeBigId">
              <el-select
                v-model="data.TypeBigId"
                placeholder="请选择所属大类"
              
                clearable
              >
                <el-option
                 
                   v-for="item in typebigList"
                  :key="item.ProductTypeBigId"
                  :value="item.ProductTypeBigId"
                  :label="item.ProductTypeBigName"
                ></el-option>
              </el-select>
         </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input
            type="number"
            v-int
            v-model="data.Sn"
            style="width: 100px"
          ></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>


        

         <el-form-item label="状态" prop="Status" >
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ProductTypeId: 0,
        ProduceTypeName: "",
        Status:1,
        ProductTypeNo: "",
        Sn: null,
        TypeBigId:null
      },
      Mode: 1,
      typebigList: [],
      code_api: require("@/api/sy/serialCode").default,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/productType").default,
      api4: require("@/api/ba/productTypeBig").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        ProductTypeNo: [{ required: true, message: "请输入编码" }],
        ProduceTypeName: [{ required: true, message: "请输入名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
       TypeBigId: [{ required: true, message: "请选择所属大类" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    
    onOpened() {
      let modeProduceTypeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeProduceTypeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },

     getOption() {
      this.loading(true); //打开加载效果

      

      this.api4.list({}).then((res) => {
        this.loading(false); //关闭加载效果
        if (res.Code == 0) {
          this.typebigList= res.Data;
        }
      });

      
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(row) {
       this.getOption();
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
      // this.code_api.previewNo("产品类别").then((res) => {
      //   console.log("serialType", res);
      //   if (res.Code == 0) {
      //     this.Mode = res.Data.Mode;
      //     this.data.ClassNo = res.Data.PreviewNo;
      //   } else {
      //     this.$message.warning("获取产品类别编号失败");
      //   }
      // });
    },
    onEditOpened(data) { this.getOption();},
    onClosed() {
      this.showList = [];
       this.typebigList = [];
    },
  },
};
</script>
